function formatGeoObject(t){const{city:e,province:o,postalCode:a}=t;return`${e.name}, ${o.abbreviation}, ${a}`}export default formatGeoObject;